"use client";
import Link from "next/link";
import TranslatedText from "@/components/TranslatedText";

export default function NotFound() {
  return (
    <div style={{ padding: "24px" }}>
      <h1><TranslatedText tKey="notFound.title" defaultValue="404 - Page not found" /></h1>
      <p>
        <TranslatedText
          tKey="notFound.description"
          defaultValue="The page you are looking for doesn't exist."
        />
      </p>
      <Link href="/dashboard">
        <TranslatedText tKey="notFound.backToDashboard" defaultValue="Back to Dashboard" />
      </Link>
    </div>
  );
}
